__webpack_require__.p = "/prcertificate/";